import React from 'react';
import './list-display.scss';
import ListDisplay from './list-display';
import { observer } from 'mobx-react-lite';
import { PolicySummaryPanelData } from './policy-summary-utils';


const AppsContent: React.FC<{data: PolicySummaryPanelData}> = observer(({ data }) => {

    return <>
        {data.summaries.map(_ => <div key={_} className={'summary-item'}>{_}</div>)}
        <ListDisplay lists={data.lists}/>
    </>;
});

export default AppsContent;